/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import 'isomorphic-fetch';

import { changeToRestoreRequestPage, changeToRestoreResponsePage } from './current-page-actions';
import { setAccessTokenInStore } from './access-token-actions';
import { setUserInfoInStore } from './user-info-actions';
import { changeStatusToFailure } from './restore-status-change-actions';
import { setTokenValidationError } from './token-validation-error-actions';
// eslint-disable-next-line node/no-missing-import
import { useIntlForAction } from '../containers/IntlApp';
import { MESSAGE_RESTORE_TOKEN_FAILURE } from '../constants/constants';

export function checkStatus (response) {
	if (response.status >= 200 && response.status < 300) {
		return response;
	}

	const error = new Error(response.statusText);
	error.response = response; // this contains the x-mashery-message-id
	error.message = response.headers.get('x-mashery-message-id');
	throw error;
}

export function validateAccessToken (accessToken) {
	return async function (dispatch) {
		const intl = useIntlForAction();
		fetch('/validate', {
			method: 'POST',
			body: JSON.stringify({ RestoreToken: accessToken }),
			headers: {
				'Content-Type': 'application/json'
			}
		}).then((response) => checkStatus(response))
			.then((response) => response.json())
			.then((response) => {
				dispatch(setAccessTokenInStore(accessToken));
				dispatch(setUserInfoInStore(response));
				dispatch(changeToRestoreRequestPage());
			})
			.catch(() => { dispatch(setTokenValidationError(intl.formatMessage({ id: 'messages.TOKEN_FAILURE', defaultMessage: MESSAGE_RESTORE_TOKEN_FAILURE }))); });
	};
}

export function processRestoreRequest (payload) {
	return async function (dispatch) {
		const request = fetch('/restore', {
			method: 'PUT',
			body: JSON.stringify(payload),
			headers: {
				'Content-Type': 'application/json'
			}
		}).then((response) => checkStatus(response))
			.then((response) => response.json())
			.catch((error) => { dispatch(changeStatusToFailure(error.message)); });

		return request.then(() => {
			dispatch(changeToRestoreResponsePage());
		});
	};
}
